import clsx from 'clsx'
import Select, { type GroupBase, type Props } from 'react-select'
import { typo } from 'shared/styles'

import css from './CustomSelect.module.scss'
import { DropdownIndicator } from './DropdownIndicator'

export const CustomSelect = <
	Option,
	IsMulti extends boolean = false,
	Group extends GroupBase<Option> = GroupBase<Option>
>({
	className,
	...props
}: Props<Option, IsMulti, Group>) => (
	<Select
		className={clsx(css.select, typo.buttonSm, className)}
		classNames={{
			control: ({ isDisabled, menuIsOpen }) =>
				clsx(css.control, typo.buttonSmB, {
					[css.disabled]: isDisabled,
					[css.open]: menuIsOpen
				}),
			dropdownIndicator: () => css.indicator,
			menu: () => css.menu,
			menuList: () => clsx(css.list, 'app-scroll-thin'),
			option: ({ isSelected }) =>
				clsx(css.option, {
					[css.selected]: isSelected
				}),
			singleValue: () => css.single,
			valueContainer: () => css.container
		}}
		// @ts-ignore false alarm because of memo
		components={{ DropdownIndicator, IndicatorSeparator: null }}
		{...props}
	/>
)
